/**
 * Detect network/connectivity failures (e.g. no internet, Supabase unreachable).
 * Used to show a specific "Unable to connect" message and optional retry.
 */
export function isNetworkError(error: unknown): boolean {
  if (error instanceof TypeError && error.message?.toLowerCase().includes('fetch')) return true;
  if (error && typeof error === 'object' && 'message' in error) {
    const msg = String((error as { message: unknown }).message).toLowerCase();
    if (msg.includes('failed to fetch') || msg.includes('network') || msg.includes('load failed')) return true;
  }
  return false;
}

export const NETWORK_ERROR_MESSAGE = 'Unable to connect. Check your internet and try again.';

export function getErrorMessage(error: unknown, fallback = 'Please try again.'): string {
  return isNetworkError(error) ? NETWORK_ERROR_MESSAGE : fallback;
}
